import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import DownloadButton from "../../../components/common components/DownloadButton.js";
import FilterPanel from "../../../components/common components/FilterPanel.js";
import ProductCard from "./ProductCard.js";
import { fetchProducts } from "../../../redux/productSlice.js";
import PaginationCard from "../../../components/Table/PaginationCard.js";
import { Button, Menu, MenuItem } from "@mui/material";
import FileOutlineIcon from "@mui/icons-material/Description";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";

const ProductMainComponent = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const productsData = useSelector((state) => state.products.productList) || [];

  const totalRecords = 1000; // Adjust as needed based on actual data
  const [pageNumber, setPageNumber] = useState(1);
  const [pageSize, setPageSize] = useState(9);
  const [isFilterPanelOpen, setIsFilterPanelOpen] = useState(false);
  const [products, setProduct] = useState();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  useEffect(() => {
    const queryParams = { searchText: "", pageSize, pageNumber };
    dispatch(fetchProducts(queryParams));
  }, [dispatch, pageSize, pageNumber]);

  useEffect(() => {
    if (productsData) {
      setProduct(productsData.listData);
    }
  }, [productsData]);

  // Handle filter logic
  const handleFilter = (criteria) => {
    const formattedCriteria = { search: criteria.search };
    const queryParams = {
      searchText: formattedCriteria.search,
      pageSize,
      pageNumber: 1,
    };
    dispatch(fetchProducts(queryParams));
  };

  // Reset filter criteria
  const handleReset = () => {
    const queryParams = { searchText: "", pageSize, pageNumber: 1 };
    dispatch(fetchProducts(queryParams));
  };

  // Open download menu
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  // Close download menu
  const handleClose = () => {
    setAnchorEl(null);
  };

  // Navigate to create product page
  const handleCreateProductBtnClick = () => {
    navigate("/create-product", { state: { actionType: "add" } });
  };

  const onPageIndexChange = (newPageIndex) => {
    setPageNumber(newPageIndex);
  };

  const onPageSizeChange = (newPageSize) => {
    setPageSize(newPageSize);
    setPageNumber(1); // Reset to first page
  };

  return (
    <>
      <div className="btn-box py-3">
        <div className="d-flex justify-content-between">
          <Button
            className="btn btn-primary greeen-btn"
            onClick={handleCreateProductBtnClick}
          >
            <i className="mdi mdi-plus-circle-outline"></i>{" "}
            {t("orderOutboxcomponents.createNew")}
          </Button>

          <div>
            <Button
              aria-controls="export-menu"
              aria-haspopup="true"
              onClick={handleClick}
              style={{ backgroundColor: "#6AA13C" }}
              className="btn btn-primary greeen-btn m-2"
              startIcon={<FileOutlineIcon />}
            >
              Export
            </Button>
            <Menu
              id="export-menu"
              anchorEl={anchorEl}
              keepMounted
              open={open}
              onClose={handleClose}
            >
              <MenuItem onClick={handleClose}>
                <DownloadButton
                  data={products}
                  filename="Product List.xlsx"
                  sheetname="Product List"
                  forModule="Product"
                />
              </MenuItem>
            </Menu>

            <Button
              className="btn btn-light grey-btn"
              onClick={() => setIsFilterPanelOpen(!isFilterPanelOpen)}
              startIcon={<FilterAltOutlinedIcon />}
            >
              {t("orderOutboxcomponents.filters")}
            </Button>
          </div>
        </div>
      </div>

      {isFilterPanelOpen && (
        <FilterPanel
          className="mb-3"
          onFilter={handleFilter}
          onReset={handleReset}
        />
      )}

      <div className="product-grid">
        {products &&
          products.map((product) => (
            <ProductCard key={product.productId} product={product} />
          ))}
      </div>

      <PaginationCard
        initialPageSize={pageSize}
        pageNumber={pageNumber}
        onPageIndexChange={onPageIndexChange}
        onPageSizeChange={onPageSizeChange}
        enablePagination={true}
        totalRecords={totalRecords}
      />
    </>
  );
};

export default ProductMainComponent;
